module.exports = __webpack_public_path__ + "static/media/permission.dfd3c8ee.png";